import CardStats from "./CardBaseStatus";
import useFetchData from "../../../../repo/get";
import { useHistory } from 'react-router-dom';

export default function CardBaseStatus({ baseSelect }) {
  const history = useHistory();
  const { data: vencidoCount } = useFetchData(`api/romaneios/count/vencidos/${baseSelect}`);
  const handleRedirect = (id) => {
    history.push(`/admin/logistica/base?data=${id}`);
  };
  return (
    <>
      <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
        <div className="flex flex-wrap">
        <button
            className="w-full lg:w-6/12 xl:w-3/12 px-2 justify-between text-left"
            onClick={() => handleRedirect("vencida")}
          >
            <CardStats
              statSubtitle="Sacas Vencidas"
              colorSelect={"bg-red-700"}
              iconSelect={"fa fa-exclamation-circle"}
              statTitle={vencidoCount?.vencido ?? 0}
            />
          </button>
          <button
            className="w-full lg:w-6/12 xl:w-3/12 px-2 justify-between text-left"
            onClick={() => handleRedirect("hoje")}
          >
            <CardStats
              statSubtitle="Sacas Vencendo Hoje"
              colorSelect={"bg-orange-500"}
              iconSelect={"fa fa-flag"}
              statTitle={vencidoCount?.vencendoHoje ?? 0}
            />
          </button>


          <button
            className="w-full lg:w-6/12 xl:w-3/12 px-2 justify-between text-left"
            onClick={() => handleRedirect("amanha")}
          >
            <CardStats
              statSubtitle="Sacas Vencendo Amanhã"
              colorSelect={"bg-yellow-500"}
              iconSelect={"fa fa-clock"}
              statTitle={vencidoCount?.vencendoAmanha ?? 0}
            />
          </button>
          <button
            className="w-full lg:w-6/12 xl:w-3/12 px-2 justify-between text-left"
            onClick={() => handleRedirect("depois")}
          >
            <CardStats
              statSubtitle="Sacas Vencendo Depois"
              colorSelect={"bg-emerald-400"}
              iconSelect={"fa fa-bolt"}
              statTitle={vencidoCount?.vencendoDepois ?? 0}
            />
          </button>
         
        </div>
      </ul>
    </>
  );
}
